import styled from 'styled-components';

import media from '../../../../styles/media.style';

export const Wrapper = styled.div`
  align-items: center;
  background-color: ${({ color }) => color};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 20px;
  position: relative;
  width: 100%;
`;

export const Icon = styled.img`
  width: 30px;

  ${media.tabletP`
    width: 40px;
  `};

  ${media.tabletL`
    width: 35px;
  `};

  ${media.desktop`
    width: 45px;
  `};
`;

export const Title = styled.h2`
  color: white;
  font-size: 20px;
  font-weight: normal;
  letter-spacing: 0.3px;
  margin: 8px 0;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 30px;
    margin: 20px 0;
  `};

  ${media.tabletL`
    font-size: 24px;
    margin: 10px 0;
  `};

  ${media.desktop`
    font-size: 30px;
    margin: 20px 0;
  `};
`;

export const Button = styled.div`
  align-items: center;
  color: white;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`;

export const ButtonLabel = styled.div`
  margin-right: 5px;
`;

export const ArrowRight = styled.div`
  border-right: 2px solid white;
  border-bottom: 2px solid white;
  display: inline-block;
  height: 8px;
  transform: rotate(-45deg);
  width: 8px;
`;



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomeTouts/TopicTout/TopicTout.style.js